import React from "react";
import { withFormsy } from "formsy-react";
import { styled } from "../stitches.config";

@withFormsy
export default class MyInput extends React.Component {
  changeValue = event => {
    this.props.setValue(event.currentTarget.value);
  };

  render() {
    const errorMessage = this.props.getErrorMessage();

    return (
      <div>
        {this.props.type === "textarea" ? (
          <textarea
            onChange={this.changeValue}
            placeholder={this.props.placeholder}
            value={this.props.getValue() || ""}
          />
        ) : (
            <input
              onChange={this.changeValue}
              type="text"
              placeholder={this.props.placeholder}
              value={this.props.getValue() || ""}
            />
          )}
        <Error>{errorMessage}</Error>
      </div>
    );
  }
}

const Error = styled("span",{
  color: "red",
  position: "relative",
  top: "-60px"
});